import {List} from "immutable";
import {splitDimensions} from "./Dimensions";

export function validateIncludes(errors, values, key, options=List()) {
  if (options.includes(values.get(key, ""))) return errors;
  return errors.set(key, "Required");
}

export function validatePresence(errors, values, key, message = "Required") {
  if (values.get(key) === null) return errors.set(key, message);
  if (values.get(key, "").length > 0) return errors;
  return errors.set(key, message);
}

export function validateArrayPresenceWithValue(errors, values, key, requiredValue, message = "Required") {
  if (values.get(key) === null) return errors.set(key, message);
  if (values.get(key, List()).size > 0 && values.get(key, List()).includes(requiredValue)) return errors;
  return errors.set(key, message);
}

export function validateMaxLength(errors, values, key, maxLength) {
  if (values.get(key) === null) return errors;
  if (values.get(key, "").length <= maxLength) return errors;
  return errors.set(key, `Max ${maxLength} characters allowed`);
}

export function validateGreaterThan(errors, values, key, numerical = 0) {
  let val = values.get(key, "");
  if (isNaN(val)) return errors.set(key, "Must be a number");
  if (parseInt(val, 10) > numerical) return errors;
  return errors.set(key, `Must be greater than ${numerical}`);
}
export function validateLowerThan(errors, values, key, numerical = 0) {
  let val = values.get(key, "");
  if (isNaN(val)) return errors.set(key, "Must be a number");
  if (parseInt(val, 10) < numerical) return errors;
  return errors.set(key, `Must be lower than ${numerical}`);
}

export function validateDimensions(errors, values, key) {
  let [w, h, l] = splitDimensions(values.get(key, ""));
  if (w === 0 || h === 0 || l === 0) return errors.set(key, "Must be a number greater than 0");
  return errors;
}

export function validateStartsWith(errors, value, key, str = "") {
  let val = value.get(key, "");
  if (val.substr(0, str.length) !== str) return errors.set(key, `Must start with ${str}`);
  return errors;
}

export function validateProductCode(errors, values, key) {
  return validateFormat(errors, values, key, new RegExp("(^WAT(-[A-Z]{3})+$)"), "Must have format WAT-ABC");
}

export function validateFormat(errors, values, key, regexp, message = "Is not a valid format") {
  let val = values.get(key, "");
  if (regexp.test(val)) return errors;
  return errors.set(key, message);
}